<div class="wrapper">
    <img class="light" src="assets/images/countries/light/{{country || 'EMPTY'}}.svg" [alt]="country">
    <img class="dark" src="assets/images/countries/dark/{{country || 'EMPTY'}}.svg" [alt]="country">
</div>